module.exports = __webpack_public_path__ + "static/media/three.80327a7c.svg";